import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card} from 'react-bootstrap'
import './daily.css'
import { CheckCircle } from 'react-bootstrap-icons';


function Success() {
    return (
        <div className="App">
                <div className="daily">
                    <Card>
                        <Card.Title>
                            <div className="success"><CheckCircle /></div>
                        </Card.Title>
                        <Card.Body>
                        您已上报成功，现在可以关闭此页面。
                        </Card.Body>
                    </Card>
                    </div>
        </div>
    );
}

export default Success;
